<template>
    <b-form id="source_submit" @submit="onSubmit">
        <div class="row">
            <div class="col-sm-12">
                <b-form-group label="Название"
                              label-for="title">
                    <b-form-input id="title"
                                  type="text"
                                  v-model="source.item.title">
                    </b-form-input>
                    <span class=" alert-danger" v-if="submitted && !source.item.title">Заполните название</span>
                </b-form-group>
                <b-form-group label="Группа">
                    <v-select :options="groups" v-model="source.item.group">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && !source.item.group">Выберите группу</span>
                </b-form-group>
                <b-form-group label="Валюта">
                    <v-select :options="currency" required v-model="source.item.currency">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && !source.item.currency">Добавьте валюту</span>
                </b-form-group>
                <b-form-group label="Ответственный МБ">
                  <v-select label="name" :options="activeUsers"
                            required v-model="source.item.responsible_buyer" placeholder="Ответственный МБ" >
                    <span slot="no-options">Совпадений не найдено.</span>
                  </v-select>
                </b-form-group>
                <b-button type="submit" class="float-right"
                          variant="primary">Сохранить и выйти
                </b-button>
            </div>
        </div>

        <div class="form-errors"></div>
    </b-form>
</template>
<script>
    import OffersService from '../../../services/offersDataService'
    import SourcesService from '../../../services/sourcesDataService'
    import UsersService from '../../../services/usersDataService'

    export default {
        name: 'CreateSourceModal',
        components: {
            OffersService: OffersService
        },
        props: {
            source: {
                default: function () {
                    return {
                        title: null,
                        group: null,
                        currency: null,
                        responsible_buyer: null
                    }
                }
            },
        },
        data() {
            return {
                groups: [],
                currency: [],
                submitted: false,
                activeUsers: []
            }
        },
        methods: {
            onSubmit(evt) {
              if (!this.source.item.title || !this.source.item.group || !this.source.item.currency) {
                evt.preventDefault();

                return;
              }

              this.source.item.responsible_buyer_id = this.source.item.responsible_buyer ? this.source.item.responsible_buyer.id : null

              SourcesService.updateSource(this.source.item)
                    .then(function (response) {
                    })
            },
            getGroups() {
                SourcesService.getGroups()
                    .then(function (groups) {
                        this.groups = groups;
                    }.bind(this))
            },
            getCurrency() {
                OffersService.getCurrency()
                    .then(function (response) {

                        this.currency = response;
                    }.bind(this))
            },
            getActiveUsers() {
              UsersService.getActiveUsers()
                .then(function (users) {
                  this.activeUsers = users;
                }.bind(this))
            },
        },
        beforeMount() {
            this.getCurrency();
            this.getGroups();
            this.getActiveUsers();
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/views/front/modals/EditSourceModal.vue